/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiCssBaselineStyle = (): Components<Theme>["MuiCssBaseline"] => ({
  styleOverrides: `
        @font-face {
          font-family: 'Inter';
          font-style: normal;
          font-display: swap;
          font-weight: 100 900;
          src: url('/fonts/Inter-VariableFont.ttf') format('truetype');
        }

        @font-face {
          font-family: 'Roboto';
          font-style: normal;
          font-display: swap;
          font-weight: 100 900;
          src: url('/fonts/Roboto-VariableFont.ttf') format('truetype');
        }
      `,
});
